import React from 'react';

import {SamplesSource} from 'notebook/sample-propagation/sample-collection/SamplesSourceCollector';
import Label from 'ui-library/bs/Label';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

/**
 * Component for selecting the source table when inserting samples into a structured table.
 * It is a controlled component; the caller must keep track of the current selection by
 * using the `onChange` callback.
 */

interface SourceTableSelectorProps {
  sources: Array<SamplesSource>;
  onChange: (sourceIndex: number) => void;
  selectedTableIndex: number;
  disabled?: boolean;
}

export default function SourceTableSelector(props: SourceTableSelectorProps): JSX.Element {
  const {sources, selectedTableIndex} = props;
  const selectedSource: SamplesSource | null = selectedTableIndex >= 0 ? sources[selectedTableIndex] : null;
  const displayValue = selectedSource?.name ?? '';

  return (
    <>
      <Label htmlFor="source_table_selector" className="u-small-spacing-top">
        Source table
      </Label>
      <SelectDropdown
        id="source_table_selector"
        disabled={Boolean(props.disabled) || sources.length === 1}
        menu={
          <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL} value={displayValue} scrollable={true}>
            {sources.map(({name, icon}, index) => (
              <Option
                key={`${name}~${index}`}
                value={name}
                icon={icon}
                onSelect={() => {
                  props.onChange(index);
                }}
              >
                {name}
              </Option>
            ))}
          </Menu>
        }
        displayName={displayValue}
      />
    </>
  );
}
